import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RegraFiscalEdicao } from '@/features/regra-fiscal/page/edicao/RegraFiscalEdicao';
import { FormEditModeRF } from '@/features/regra-fiscal/types/FormEditModeRF';
import { StringToIdpkSchema } from '@/std/schema';

const ParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal(FormEditModeRF.CadastrarNova),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum([
            FormEditModeRF.CadastrarTemplate,
            FormEditModeRF.Editar,
            FormEditModeRF.Visualizar,
            FormEditModeRF.Clonar,
        ]),
        idpk: StringToIdpkSchema,
    }),
]);

const RegraFiscalEdicaoSearchRegrasSchema = z.object({
    cofins: z.number().optional(),
    ibscbs: z.number().optional(),
    icms: z.number().optional(),
    informacoes: z.number().optional(),
    ipi: z.number().optional(),
    is: z.number().optional(),
    pis: z.number().optional(),
    servico: z.number().optional(),
});

export type RegraFiscalEdicaoSearchRegras = z.infer<typeof RegraFiscalEdicaoSearchRegrasSchema>;

// biome-ignore assist/source/useSortedKeys: type inference
export const Route = createFileRoute('/a/regra-fiscal/$action/{-$idpk}')({
    validateSearch: RegraFiscalEdicaoSearchRegrasSchema,
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
    component: Component,
});

function Component() {
    const { action, idpk } = Route.useParams();
    const regras = Route.useSearch();

    return <RegraFiscalEdicao idpk={idpk} mode={action} regras={regras} />;
}
